import React, { useState } from "react";


const LocalSelector = ({ locale, available_languages }) => {

  // Funzione che chiede al server il cambio della lingua di default associata all'utente
  const handleChangeLocale = (newLocale) => {
    window.localStorage.setItem('user_locale', newLocale);
    const url="/users/update_user_language"

    fetch(url + ".json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ locale: newLocale }),
    })
      .then((res) =>  {})
      .then((data) => {
        if ('URLSearchParams' in window) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("locale", newLocale);
          window.location.search = searchParams.toString();
        }
      })
      .catch((error) => {
        console.error("ERROR:", error);
      });

  }


  const handleDisplayLangSelector = () => {
    document.querySelector(".lang-selector__lang--active").parentNode.classList.toggle("lang-selector--active");
  }

  const handleHideLangSelector = () => {
    document.querySelector(".lang-selector__list").parentNode.classList.remove("lang-selector--active");
  }





  return <div className="lang-selector2 ml-2 ml-sm-4">
      <span className="lang-selector__lang lang-selector__lang--active w-100" id="current-locale" onClick={handleDisplayLangSelector}>
        <img src={window.location.origin + `/images/langs/${locale}.svg`} className="lang-selector__flag" alt={locale} id="active-lang" height="27" width="27"/>
      </span>

    {
      available_languages && available_languages.length >= 1 &&
        <ul className="lang-selector__list z-index-130" onMouseLeave={handleHideLangSelector}>
          {
            available_languages.map((l) =>
              <li key={l} id={`${l}-option-locale`}>
                <span className="lang-selector__lang lang w-100" id="lang-option-1" aria-label={l} onClick={() => handleChangeLocale(l)}>
                  <img src={window.location.origin + `/images/langs/${l}.svg`} className="lang-selector__flag" alt={l} id="lang-img-1" height="27" width="27"/>
                </span>
              </li>
            )
          }
        </ul>
    }
  </div>
};

export default LocalSelector;